export default __webpack_public_path__ + "static/media/noasklistlist.5907a11d.png";